import React, { useState } from 'react';
import { Box, Collapse, IconButton, Button, TableRow, TableCell } from '@mui/material';
import { Edit, KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import MenuOptions from '../MenuOptions';
import style from './style';

const { tableRowStyle, subtableRowStyle } = style;

export default function Row({
  row,
  limit,
  thereIsComponent,
  expandible,
  configButtonEvents,
  configButtonModals,
  configButton,
  editButton,
  editButtonEvent,
}) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <TableRow sx={tableRowStyle}>
        {expandible ? (
          <TableCell>
            <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
              {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
            </IconButton>
          </TableCell>
        ) : null}

        {row.map((data, index) => {
          const id = `${index}a`;
          return index < limit ? (
            <TableCell key={id} align="center" style={{ alignItems: 'center' }}>
              {thereIsComponent ? thereIsComponent(row, index) : data}
            </TableCell>
          ) : null;
        })}
        {editButton ? (
          <TableCell align="center">
            <Button onClick={() => editButtonEvent(row)}>
              <Edit />
            </Button>
          </TableCell>
        ) : null}
        {configButton.length ? (
          <TableCell align="center">
            <MenuOptions
              options={configButton}
              optionsEvents={configButtonEvents}
              optionIsModal={configButtonModals}
              data={row}
            />
          </TableCell>
        ) : null}
      </TableRow>
      <TableRow sx={subtableRowStyle}>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={row.length + 1}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 0 }}>{expandible ? expandible(row) : null}</Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}
